module.exports = __webpack_public_path__ + "static/media/vibino-feature-Transparent-pic3.f0c7011b.jpg";